import Service from "../Service";

const resource = "DocumentSignature/";

export default {
    save(prm, requestID) {
        return Service.post(resource + "save", prm, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    listDocument(parameters, requestID) {
        return Service.post(resource + "ListMobile", parameters, {
            params: { requestID: requestID },
        });
    },
    saveMobile(parameters, requestID) {
        return Service.post(resource + "saveMobile", parameters, {
            params: { requestID: requestID },
        });
    },

    saveElectronicSignature(parameters, requestID) {
        return Service.post(resource + "saveElectronicSignature", parameters, {
            params: { requestID: requestID },
        });
    },
    

};